import { createAction } from '@reduxjs/toolkit';
import getCurrentDirname from '~/utils/get-current-dirname/get-current-dirname';

const prefix = getCurrentDirname(__dirname);

export const updateWsReconnectionTime = createAction(`${prefix}/UPDATE_WS_RECONNECTION_TIME`);
